import styled from "styled-components";

const EditableDescription = styled.textarea`
  border: none;
  padding: 5px 10px 10px 10px;
  box-sizing: border-box;
  font-size: 12px;
  font-family: "PT Sans";
  line-height: 17px;
  resize: none;
  background: #a855f7;
  color: white;
  font-weight: 500;
  border-radius: 5px;
  min-height: 50px;

  &:focus {
    outline: none;
    background: #8b45e6;
  }
  &::placeholder {
    color: rgba(255, 255, 255, 0.7);
  }
`;

export default EditableDescription; 